import { r as registerInstance, c as createEvent, h } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { F as html2plain } from './utils-15ad90ec.js';
import './_commonjsHelpers-ba3f0406.js';
import './request.constants-deb285e0.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const rangePillsCss = ":host{display:block}.pills{line-height:44px;min-height:44px;display:none}@media screen and (min-width: 980px){.pills{display:block;margin:-6px 0 12px}}.pills__tooltip{font-size:14px;line-height:1.4285714286;font-weight:700}";

let RangePills = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.removePill = createEvent(this, "removePill", 7);
    this.pills = [];
    this.handleClickClose = (navigationState, value, sourceId) => {
      this.pillsEl.dispatchEvent(new CustomEvent('track_analytics', {
        detail: {
          event: 'refinementStateChanged',
          isChecked: false,
          refinementId: `${value || sourceId}_${navigationState.replace(/\?N/g, '?n')}`,
        },
        bubbles: true,
        composed: true,
      }));
      this.removePill.emit(navigationState);
    };
  }
  render() {
    var _a;
    return (((_a = this.pills) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("div", { class: classnames('pills'), ref: (el) => {
        this.pillsEl = el;
      } }, this.pills.map((item) => (h("pes-tooltip-wrapper", { position: "top" }, h("se-chip", { slot: "tooltip-activator", canClose: true, value: html2plain(item.label), onDidClose: () => this.handleClickClose(item === null || item === void 0 ? void 0 : item.navigationState, item === null || item === void 0 ? void 0 : item.charValueId, item === null || item === void 0 ? void 0 : item.sourceId) }), h("div", { slot: "tooltip-content", class: "pills__tooltip" }, item.characteristicName)))))));
  }
};
RangePills.style = rangePillsCss;

export { RangePills as pes_range_pills };
